export default "__VITE_ASSET__3cb23382__"